module.exports = __webpack_public_path__ + "img/Logo.de6a1162.png";